module.exports = __webpack_public_path__ + "img/main_heading_NO.747a94bb.svg";